import Image from 'next/image'
import { useState } from 'react'
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog'
import { useTranslation } from '@/app/i18n/client'

const ImagePreview = ({
  images,
  title,
  cardType,
}: {
  images: { url: string }[]
  title?: string
  cardType?: string
}) => {
  const { t } = useTranslation()
  const [previewImageIndex, setPreviewImageIndex] = useState(0)
  const [mainImageIndex, setmainImageIndex] = useState(0)

  const [openPreview, setPreviewFormController] = useState(false)

  return (
    <div className="flex flex-col gap-3.5 mobile:hidden">
      {/* Main Image Preview */}
      <div className="h-[306px] w-[409px] relative">
        <Dialog open={openPreview} onOpenChange={setPreviewFormController}>
          <div className="h-[306px] w-[409px] bg-[#ededed] overflow-hidden rounded-sm rounded-tr-sm rounded-br-none">
            <DialogTrigger asChild>
              <Image
                loading="lazy"
                width={500}
                height={500}
                src={
                  images?.[mainImageIndex]?.url ??
                  '/assets/Icons/noImage/noImage2.svg'
                }
                alt="offer-img"
                className={`h-[306px] w-[409px] cursor-pointer ${images?.length > 0 ? 'object-cover' : 'object-contain'}`}
              />
            </DialogTrigger>
          </div>
          <DialogContent className="!min-w-[700px] max-w-[80%]  overflow-scroll rounded-md min-h-[35%] max-h-[80%]">
            <div className="flex flex-row gap-6 justify-between relative items-center">
              {/* Main preview image */}
              <div className="flex w-[70%] h-[100%] relative bg-gray-200 rounded-md justify-center items-center">
                <div className="flex items-center p-2 justify-center">
                  <Image
                    className="w-[600px] h-[500px]  rounded-sm object-contain"
                    src={
                      images?.[previewImageIndex]?.url ??
                      '/assets/Icons/noImage/noImage2.svg'
                    }
                    alt="Selected image"
                    width={600}
                    height={500}
                  />
                </div>
              </div>
              {/* Thumbnail Images */}
              <div className="flex flex-col w-[30%] sm:w-[30%] items-center sm:items-start mb-auto mt-3 sm:mt-[50%] px-4 py-2 mr-auto">
                <h1 className="font-ns_semibold my-6 text-wrap text-black text-[20px] text-center sm:text-left">
                  {title}
                </h1>
                <div className="flex flex-wrap justify-center sm:justify-start gap-3">
                  {images?.map((image, idx) => (
                    <div
                      key={idx}
                      className={`w-20 h-20 cursor-pointer rounded-md hover:ring-2 hover:ring-amber-600 overflow-hidden ${
                        previewImageIndex === idx ? 'ring-4 ring-amber-500' : ''
                      }`}
                      onClick={() => setPreviewImageIndex(idx)}
                    >
                      <Image
                        className="w-full h-full object-cover"
                        src={image.url}
                        alt={`Thumbnail ${idx}`}
                        width={80}
                        height={75}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <span
          className={`text-sm  ${cardType === 'alert' ? 'bg-orange_tag' : 'bg-secondary'} w-fit rounded-l-sm text-white absolute p-1 px-3 right-0 bottom-0 `}
        >
          {cardType === 'alert' ? t('ALERT') : t('OFFER')}
        </span>
      </div>

      {/* Thumbnails */}
      <div className="grid grid-cols-4 gap-7 gap-y-4 h-auto mt-2">
        {images?.map((item, idx) => (
          <div
            key={idx}
            className={`w-[80px] h-[75px] rounded-md hover:ring-2 hover:ring-amber-600 ${mainImageIndex === idx ? 'ring-4 ring-amber-500' : ''}`}
            onClick={() => {
              setPreviewImageIndex(idx)
              setmainImageIndex(idx)
            }}
          >
            <Image
              width={500}
              height={500}
              className="w-full h-full object-cover rounded-md"
              src={item?.url ?? '/assets/Icons/noImage/noImage2.svg'}
              alt={`Thumbnail ${idx}`}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ImagePreview
